import React from 'react';
import classnames from 'classnames';

const Reaction = ({ title, kind, colors, values, onChange }) => {
  const handleChange = (event) => {
    onChange({ [kind]: event.target.checked });
  };
  const inputClassNames = {
    positive: '-like',
    negative: '-dislike',
    confusing: '-confusing'
  };
  const switcherClassNames = {
    positive: '-success',
    negative: '-danger',
    confusing: '-warning'
  };

  return (
    <label
      className={ classnames("form-switch-group", switcherClassNames[kind]) }
      style={ { color: colors[kind] } }
    >
      <input
        className={ classnames("hide survey-reactions-control_checkbox", inputClassNames[kind]) }
        checked={ values[kind] }
        type="checkbox"
        onChange={ handleChange }
      />
      <div
        className={ classnames("form-switch", switcherClassNames[kind]) }
        style={ { backgroundColor: colors[kind], color: colors[kind] } }
      />
      { title }
    </label>
  );
};

export default Reaction;
